module.exports = __webpack_public_path__ + "media/src/components/GenerateDocument/images/SS-icon-checkmark-3aadb533777195175679978e823aff1c.gif";